import { AuthenticationApi } from "@/assets/js/ApiInterface";
import AuthData from "@/assets/js/models/user/AuthData";
async function updateAuthenticatedUser(context) {
  try {
    let {
      data
    } = await await context.store.dispatch('SendRequest', AuthenticationApi.asyncCheckAuth(AuthData));
    if (data instanceof AuthData) {
      await context.store.dispatch('setAuthData', data);
    }
  } catch (e) {
    console.log('email verification failure', e);
  }
}
export { updateAuthenticatedUser };